import styled from 'styled-components';

export default styled.span`
    font-size: 14px;
    font-weight: 600;
`;
